/**
 * The highest score a prediction may be picked at.
 *
 * The picker's own ceiling, in its own module rather than inside `ScorePicker.tsx`, so anything
 * that sets a score without going through the +/− buttons agrees on the same bound. The server
 * accepts up to 99; this is the tighter thing the UI offers.
 */
export const MAX_PICKER_SCORE = 20
